export const dateGenerator = (hours: number, minutes: number, date?: Date) => {
  const dateToReturn = date ?? new Date();
  dateToReturn.setHours(hours, minutes, 0, 0);

  return dateToReturn;
};
